/* eslint-disable unicorn/consistent-destructuring */

import angular from 'angular';
import _ from 'lodash-es';
import Query from '~/scripts/services/model/query';
import Node from '~/scripts/services/model/node';
import APIV5 from '~/models/api';
import QueryColumn from '~/scripts/services/model/query-column';
import QueryFrom from '~/scripts/services/model/query-from';
import QueryWhereChild from '~/scripts/services/model/query-where-child';
import QueryWhereNode from '~/scripts/services/model/query-where-node';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';
import QueryWhereRules from '~/scripts/services/model/query-where-rules';
import templateModalQueryJson from '~/components/query/query-editor/modal/modal-query-json.html';
import ModalQueryJsonController from '~/components/query/query-editor/modal/modal-query-json.controller';
import controller, { fixComponentOptionsActionInsert, setWhere } from './ktable.controller';
import template from './ktable.html';
import KtableComponent from './ktable.component';

/**
 * Parent2
 *
 * @typedef {Object} Parent2
 * @property {Array<*>} definedby definedby
 * @property {*} customColumns customColumns
 * @property {*} krepre_mode krepre_mode
 * @property {Query} query query
 * @property {Object.<string, *>} classRepresentations classRepresentations
 * @property {Object.<string, *>} valuesRepresentations valuesRepresentations
 */

/**
 * Parent1
 *
 * @typedef {Object} Parent1
 * @property {*} $parent $parent
 * @property {*} form form
 * @property {*} forms forms
 * @property {*} files files
 */

/**
 * @typedef {Object} Component
 * @property {Query} query query
 */

/**
 * @typedef {Object} MyScope The current scope
 * @property {Object} options Options
 * @property {boolean} readOnly readOnly
 * @property {boolean} forms forms
 * @property {Array<*>} files files
 * @property {*} builder builder
 * @property {Component} component component
 * @property {*} $parent $parent
 */

/* globals KtableFormConfig */

/**
 * @typedef {KtableFormConfig.Scope} Scope The current scope
 */

const ktableConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('ktable', {
		/**
		 * @param {import('angular').auto.IInjectorService} $injector
		 * @param {Scope} $scope
		 * @param {import('angular').translate.ITranslateService} $translate
		 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
		 * @param {any} Notification
		 */
		onEdit: /* @ngInject */ (
			$injector,
			$scope,
			$translate,
			$uibModal,
			Notification,
		) => {
			/** @type {any} */
			// @ts-ignore
			const { component } = $scope;

			$scope.cols = [];

			$scope.mfFastImportCard = component.options.actions.fastImport ? '1-1' : '0-1';

			$scope.valuesRepresentations = {};

			fixComponentOptionsActionInsert(component);

			$scope.$watch('component.query', () => {
				if (!(component.query instanceof Query)) {
					component.query = new Query(component.query);
				}
			});

			$scope.$watch('component.options.actions.fastImport', () => {
				$scope.mfFastImportCard = component.options.actions.fastImport ? '1-1' : '0-1';
			});

			$scope.addFrom = object => {
				let isFromExist = false;

				if (!Array.isArray(component.query.from)) {
					component.query.from = [];
				}

				for (const from of component.query.from) {
					if (from !== undefined && from.node === object.kid) {
						isFromExist = true;
					}
				}

				if (isFromExist) {
					return Notification.warning({
						title:   $translate.instant('error.title'),
						message: 'Cette classe a déjà été sélectionnée',
					});
				}
				if (object && object.kid) {
					component.query.from = [];
					return APIV5.instance.objectInfo({ kid: object.kid }, { id: 'ktable.add-from' }).then(data => {
						component.query.from.push(new QueryFrom({
							node:              object.kid,
							name:              object.name,
							// @ts-ignore
							type:              object.type || object.type_kid,
							inherits_extended: !data.error && data.parent_inherits.nb > 0 ? 0 : -1,
						}));
						component.query.select.length = 0;
						return component.query.from;
					}).catch(() => {});
				}

				return false;
			};

			$scope.colGetId = (/** @type {QueryColumn} */ col) => {
				let returnValue;

				if (col && typeof col === 'object' && 'kid' in col) {
					returnValue = col.kid;
					if (col.linker_kid !== '0') {
						returnValue += `|${col.linker_kid}`;
					}
				}
				return returnValue;
			};

			$scope.colGetKey = (/** @type {QueryColumn} */ col) => {
				let index = -1;

				for (const [k, c] of $scope.cols.entries()) {
					if (c.kid === col.kid && c.linker_kid === col.linker_kid) {
						index = k;
					}
				}

				return index;
			};

			$scope.colGetName = (/** @type {QueryColumn} */ col) => {
				let returnValue = col.name;

				// if (!ret) {
				// 	const cs = scope.$new();
				// 	KTranslate.request(cs, col.kid).then(text => {
				// 		col.name = text;
				// 	});
				// }

				if (col.linker_kid !== '0' && col.linker_info) {
					// const csl = scope.$new();
					// KTranslate.request(csl, col.linker_kid).then(text => {
					// 	col.linker_info.name = text;
					// });
					returnValue += ` :: ${col.linker_info.name}`;
				}

				return returnValue;
			};

			$scope.getRepresentations = (/** @type {string | number} */ columnId) => {
				const repre = $scope.representations[columnId];
				if (repre) {
					const all = repre.repre_all;
					const allArray = [];
					for (const [key, value] of Object.entries(all)) {
						allArray.push({
							lang_kid: key,
							name:     value?.name,
							kid:      repre.kid,
						});
					}
					return allArray;
				}
				return [];
			};

			$scope.hasColRepre = () => {
				let returnValue = false;

				if ($scope.node && $scope.node.length === 1) {
					for (const c of $scope.cols) {
						if (c.kid === $scope.node[0].kid) {
							returnValue = true;
						}
					}
				}

				return returnValue;
			};

			$scope.openJSON = () => {
				$uibModal.open({
					template:     templateModalQueryJson,
					controller:   ModalQueryJsonController,
					controllerAs: '$ctrl',
					size:         'lg',
					resolve:      {
						query: () => component.query.export(),
					},
				});
			};

			$scope.$on('query-class-deleteClass', () => {
				component.query.reset();
			});

			if (
				component.query.where instanceof QueryWhereChild
				&& !component.query.where.node
				&& component.query.from.length > 0
			) {
				console.warn('attempt to fix query');
				const node = new Node($injector, component.query.from[0].node);
				node.setName(component.query.from[0].name);
				node.type_kid = component.query.from[0].type;
				component.query.where.node = new QueryWhereNode({
					kid:  node.kid,
					name: node.getName(),
					type: node.type_kid,
				});

				if (!component.query.where.rules) {
					component.query.where.rules = new QueryWhereRules();
					const rule = new QueryWhereRule({
						field:    'kid',
						operator: 'equal_kid',
						value:    [{ kid: '_KID_' }],
					});
					rule.setNode(component.query.where.node);
					component.query.where.rules.items.push(rule);
				}
			}

			if (component.node?.length === 1 && _.isEmpty(component.query)) {
				/** @type {any} */
				const node = component.node[0];
				(async () => {
					await $scope.addFrom(node);
					if (component.cols) {
						component.query.select = [
							new QueryColumn({
								kid:    node.kid,
								hidden: true,
								// @ts-ignore
								root:   true,
								name:   node.name,
								type:   node.type_kid,
							}),
						];

						for (const col of component.cols) {
							// If the col should be included inside the query
							if (col.includeInQuery === true || !('includeInQuery' in col)) {
								const select = new QueryColumn({
									// @ts-ignore
									kid:        col.kid,
									// @ts-ignore
									linker_kid: col.linker_kid,
									hidden:     false,
									name:       col.name,
									path:       [
										{
											kid:        node.kid,
											name:       node.name,
											flow:       undefined,
											linker_kid: '0',
										},
									],
									// @ts-ignore
									type:       col.type_kid,
								});

								// noinspection JSUnresolvedVariable
								if (col?.settings?.valueRepresentation) {
									// @ts-ignore
									select.node = col.settings.valueRepresentation.kid;
								}

								select.path.push({
									kid:        col.kid,
									name:       col.name,
									flow:       'down',
									linker_kid: col.linker_kid || '0',
								});

								if (col.linker_kid !== '0') {
									// @ts-ignore
									select.linker_info = col.linker_info;
								}

								component.query.select.push(select);
							}
						}

						if (
							$scope.cols.length === 0
							&& component.query.select.length > 0
							&& component.query.select[0].kid === node.kid
						) {
							component.query.select[0].hidden = false;
						}
					}

					if (component.filter) {
						setWhere(
							component.query,
							component.filter,
							node,
						);
					}
				})();
			}

			// clean from
			component.query.from = component.query.from?.map((/** @type {any} */ from) => (new QueryFrom({
				inherits_extended: from.inherits_extended,
				name:              from.name,
				node:              from.node,
				type:              from.type,
			})));
		},
		title:      'K-Table',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings:   new KtableComponent(),
		icon:       'fa fa-table',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/ktable/display.html',
			},
			{
				name:     'Query',
				template: 'kform/components/ktable/query.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'templates/components/common/api2.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
	});
};

export default angular.module('app').config(ktableConfig);
